export const TILE_PX = 32; // px per tile at zoom 1

export class Camera {
  x = 0; y = 0; // world tiles at screen centre
  zoom = 1;
  width = 1; height = 1;
  /** perspective factor: screen offset per metre of height, as fraction of distance from centre */
  perspective = 0.01;

  /** (Oct 2, the owner's 5120×1440 desktop: 3.5× the world of a 1080p window to simulate and draw, frames of 18 ms — and in a shared
   *  world a view much further than everyone else's) a window bigger than 2560×1440 shows no more of the world than that one does at
   *  the same zoom: the tiles grow with it instead */
  static readonly MAX_VIEW_PX = 2560 * 1440;
  get fit(): number { return Math.max(1, Math.sqrt((this.width * this.height) / Camera.MAX_VIEW_PX)); }
  get scale(): number { return TILE_PX * this.zoom * this.fit; }

  toScreen(wx: number, wy: number, h = 0): [number, number] {
    const s = this.scale;
    let sx = (wx - this.x) * s + this.width / 2;
    let sy = (wy - this.y) * s + this.height / 2;
    if (h) {
      const f = 1 + h * this.perspective;
      sx = this.width / 2 + (sx - this.width / 2) * f;
      sy = this.height / 2 + (sy - this.height / 2) * f;
    }
    return [sx, sy];
  }
  toWorld(sx: number, sy: number): [number, number] {
    const s = this.scale;
    return [(sx - this.width / 2) / s + this.x, (sy - this.height / 2) / s + this.y];
  }
  /** visible world rect (tiles), with margin */
  bounds(margin = 2): { x0: number; y0: number; x1: number; y1: number } {
    const hw = this.width / 2 / this.scale + margin, hh = this.height / 2 / this.scale + margin;
    return { x0: this.x - hw, y0: this.y - hh, x1: this.x + hw, y1: this.y + hh };
  }
}
